export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/tb-vip-title.302b2411.png";